import React, { createContext, useCallback, useContext, useState } from 'react';
import InnerCircleModal from '../components/InnerCircleModal';

const Ctx = createContext({ openIC: () => {}, closeIC: () => {} });

/**
 * Global provider that lets any component call `openInnerCircle()` to show
 * the Inner Circle membership modal. Mount once at the app root.
 */
export const InnerCircleProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openIC = useCallback(() => setOpen(true), []);
  const closeIC = useCallback(() => setOpen(false), []);
  return (
    <Ctx.Provider value={{ openIC, closeIC }}>
      {children}
      <InnerCircleModal open={open} onClose={closeIC} />
    </Ctx.Provider>
  );
};

export const useInnerCircle = () => useContext(Ctx);
